import React from 'react';
export function VideoIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.56 7.17a1 1 0 00-.93-.1L17 8.52V8a3 3 0 00-3-3H5a3 3 0 00-3 3v8a3 3 0 003 3h9a3 3 0 003-3v-.52l3.63 1.45A1 1 0 0022 16V8a1 1 0 00-.44-.83zM15 16a1 1 0 01-1 1H5a1 1 0 01-1-1V8a1 1 0 011-1h9a1 1 0 011 1v8zm5-1.48l-3-1.2v-2.64l3-1.2v5.04z"
  }));
}